import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { InputLabel } from "@material-ui/core";

import { HouseFuseIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";

export const AdjustableLoadHouseConnectionFuseCapacityForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } =
        useFormModel<ChangeNames.ADJUSTABLE_LOAD_HOUSE_CONNECTION_FUSE_CAPACITY>();
    return (
        <Fragment>
            <h3 className={classes.h3} style={{ marginTop: 28, marginBottom: 16 }}>
                Ist Ihnen die Größe der Hausanschlusssicherung bekannt?
            </h3>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<HouseFuseIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Hausanschlusssicherung
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Beachten Sie, das Öffnen des Hausanschlusskastens ist ausschließlich
                            durch einen konzessionierten Elektroinstallateur gestattet. Die Größe
                            der Hausanschlusssicherung erhalten Sie ggf. von Ihrem
                            Elektroinstallateur.
                        </p>
                    </Fragment>
                }
                useSwitch={
                    <Switch
                        checked={values.adjustableLoadHouseConnectionFuseCapacity.value.installed}
                        {...getFieldProps("adjustableLoadHouseConnectionFuseCapacity.value.installed")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.adjustableLoadHouseConnectionFuseCapacity.value.installed = checked;
                                values.adjustableLoadHouseConnectionFuseCapacity.value.current.amount =
                                    checked ? 0 : null;
                            })
                        }
                    />
                }
                detailCondition={values.adjustableLoadHouseConnectionFuseCapacity.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Sicherungsgröße
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={
                                values.adjustableLoadHouseConnectionFuseCapacity.value.current.precision
                            }
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.adjustableLoadHouseConnectionFuseCapacity.value.current.unit}
                            value={
                                values.adjustableLoadHouseConnectionFuseCapacity.value.current.amount || ""
                            }
                            placeholder="0"
                            onValueChange={(v) =>
                                setValues((values) => {
                                    values.adjustableLoadHouseConnectionFuseCapacity.value.current.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.adjustableLoadHouseConnectionFuseCapacity.error != null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
